var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"contentContainer lowIncomeMain"},[_c('h2',[_vm._v(_vm._s(_vm.displayName("TPL_CON_1")))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.largeText('TPL_CON_1'))}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.largeText('TPL_CON_2'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }